import classNames from 'classnames';
import { Frequency, SUBSCRIPTION_TIERS, Tier } from './subscriptions.constants';
import { TierCard } from './TierCard';

export const TeirContent = (props: Props) => {
  const { proceed } = props;

  return (
    <div className="px-6 lg:px-8">
      <div className="mx-auto max-w-4xl text-center">
        <p className={classNames('text-4xl font-bold tracking-tight text-gray-800 sm:mt-8 sm:text-5xl')}>
          Upgrade Your Account
        </p>
      </div>
      <p className="mx-auto mt-5 max-w-2xl text-center text-xl font-semibold leading-8 text-gray-800">
        Unlock all of the features necessary to promote and profit from referral-based income streams.
      </p>
      <div className="mx-auto mt-10 flex flex-col justify-center">
        {SUBSCRIPTION_TIERS.map((tier) => (
          <div className="mx-auto max-w-md">
            <TierCard tier={tier} proceed={proceed} />
          </div>
        ))}
      </div>
    </div>
  );
};

type Props = {
  proceed: (tier: Tier, freq: Frequency) => void;
};
